export default __webpack_public_path__ + "static/media/d305c3a15086ec3222588041cdc818c71580732224020.1fbefda2.webp";